import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Forum Email',
  basePath: '/forumemail',
  columns: [
    { key: 'forumemail_name', label: 'Name', sortable: true },
    { key: 'forumemail_email', label: 'Email', sortable: true },
    { key: 'via', label: 'Source', sortable: true,
      render: (v) => {
        if (v === '' || v == null) return 'Portal user';
        return v === 'GP' ? 'Google+' : 'Facebook';
      } },
    { key: 'forumemail_block', label: 'Block', sortable: true,
      render: (v) => v == 1 ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'forumemail_name', label: 'Name', type: 'text', required: true },
    { key: 'forumemail_email', label: 'Email', type: 'text' },
    { key: 'forumemail_block', label: 'Block', type: 'yesno', defaultValue: '0' },
  ],
  defaultSort: { field: 'forumemail_name', dir: 'desc' },
});
